var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-wrap"},[_c('audio',{attrs:{"src":_vm.publicPath + 'static/uploads/' + _vm.audiodata['url'],"controls":""}}),_c('div',{staticClass:"ring-wrap",on:{"click":function($event){$event.preventDefault();_vm.playing = !_vm.playing}}},[_c('svg',{staticClass:"progress-ring",attrs:{"width":"36","height":"36"}},[_c('circle',{staticClass:"progress-ring__circle",style:('stroke-dasharray: ' +
						_vm.circumference +
						', ' +
						_vm.circumference +
						'; stroke-dashoffset: ' +
						_vm.svgoffset +
						';'),attrs:{"stroke":"black","stroke-width":"1","r":"18","fill":"transparent"}})]),_c('span',{staticClass:"play-icon",class:{ playing: _vm.playing }})])])}
var staticRenderFns = []

export { render, staticRenderFns }